<template>
  <CommonPages id="privacy" class="privacy common-text" headerTheme="dark"
    titlePrefix="Privacy Policy">
    <div class="common-text__container">
      <div class="common-text__content pc_padding">
        <h1 class="common-text__title">Privacy Policy</h1>

        <div class="common-text__section">
          <h2 class="common-text__section-title">1. Introduction</h2>
          <p class="common-text__paragraph">
            At {{ domainConfig?.IAmURL }}, your privacy is important to us. This Privacy Policy
            outlines how we collect, use, and protect your personal information when you visit our
            Website.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">2. Information Collection</h2>
          <p class="common-text__paragraph">
            We may collect personal information such as your name, email address, and other details
            if you choose to subscribe to our newsletter or contact us through the Website. We also
            collect non-personal data, such as IP addresses and browsing information, through
            cookies and other tracking technologies.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">3. Use of Information</h2>
          <p class="common-text__paragraph">
            The personal information we collect is used to improve your experience on the Website,
            provide customer support, and send periodic updates or promotional materials if you have
            opted to receive them. Non-personal information is used for analytical purposes to help
            us understand user behavior and enhance our content.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">4. Data Protection</h2>
          <p class="common-text__paragraph">
            We implement security measures to protect your personal information from unauthorized
            access or disclosure. However, no method of transmission over the Internet is completely
            secure, and we cannot guarantee the absolute security of your data.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">5. Sharing of Information</h2>
          <p class="common-text__paragraph">
            We do not share your personal information with third parties, except as required by law
            or to service providers who assist in operating the Website and providing services to
            you. These service providers are bound by confidentiality agreements.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">6. Cookies</h2>
          <p class="common-text__paragraph">
            The Website may use cookies to enhance user experience, track users' activity, and
            gather information about usage patterns. You may disable cookies through your browser
            settings, but doing so may affect your user experience.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">7. Changes to the Privacy Policy</h2>
          <p class="common-text__paragraph">
            {{ domainConfig?.IAmURL }} reserves the right to update this Privacy Policy at any time.
            Any changes will be posted on this page, and the updated policy will be effective
            immediately upon publication.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">8. Contact Us</h2>
          <p class="common-text__paragraph">
            If you have any questions about this Privacy Policy or our practices, feel free to
            contact us through the contact information provided on the Website.
          </p>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Privacy',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'domainConfig'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.common-text {
	background: #fff;
	min-height: 100vh;

	&__content {
		margin: 0 auto;
		padding: rem(60) rem(120);
		width: 100%;
	}

	&__title {
		color: #141414;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(24);
		margin-bottom: rem(24);
	}

	&__section {
		margin-bottom: rem(40);
	}

	&__section-title {
		color: #141414;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(28);
		margin-bottom: rem(16);
	}

	&__subsection-title {
		color: #141414;

		font-size: rem(18);
		font-weight: 600;
		line-height: rem(24);
		margin-top: rem(20);
		margin-bottom: rem(12);
	}

	&__paragraph {
		color: #777;

		font-size: rem(12);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
	}

	&__link {
		color: var(--theme-color);
		text-decoration: underline;
		text-decoration-thickness: auto;
		text-decoration-style: solid;
		text-decoration-skip-ink: none;

		&:hover {
			opacity: 0.8;
		}
	}

	&__list,
	&__numbered-list {
		color: #777;

		font-size: rem(14);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
		padding-left: rem(20);
	}

	&__list {
		list-style-type: disc;
	}

	&__numbered-list {
		list-style-type: decimal;
	}

	&__list-item,
	&__numbered-list-item {
		margin-bottom: rem(8);

		&:last-child {
			margin-bottom: 0;
		}
	}

	&__table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: rem(20);

		font-size: rem(14);

		th,
		td {
			border: 1px solid #e9e9e9;
			padding: rem(10) rem(16);
			text-align: left;
		}

		th {
			background-color: #f5f7fa;
			color: #141414;
			font-weight: 600;
		}

		td {
			color: #777;
		}
	}

	&__blockquote {
		border-left: 4px solid #405ff2;
		padding: rem(16) rem(20);
		background-color: #f5f7fa;
		margin: rem(16) 0;
		color: #777;

		font-size: rem(14);
		font-style: italic;
		line-height: rem(24);
	}

	&__code-block {
		background-color: #f5f7fa;
		border-radius: rem(8);
		padding: rem(16);
		margin: rem(16) 0;
		overflow-x: auto;

		pre {
			margin: 0;

			code {
				color: #777;
				font-size: rem(14);
				line-height: 1.5;
			}
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.common-text {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);

		&__title {
			font-size: rem(24);
			line-height: rem(24);
		}

		&__section-title {
			font-size: rem(16);
			line-height: rem(24);
		}
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.common-text {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);

		&__content {
			padding: 0 rem(16);
		}

		&__content {
			max-width: rem(343);
			padding: rem(20);
		}

		&__title {
			font-size: rem(24);
			line-height: rem(24);
			margin-bottom: rem(20);
		}

		&__section-title {
			font-size: rem(16);
			font-style: normal;
			font-weight: 900;
			line-height: rem(24); /* 150% */
			margin-bottom: rem(8);
		}

		&__subsection-title {
			color: #141414;

			font-size: rem(12);
			font-weight: 600;
			line-height: rem(24);
			margin-top: rem(16);
			margin-bottom: rem(8);
		}

		&__paragraph {
			color: #777;

			font-size: rem(12);
			font-weight: 400;
			line-height: rem(24);
			margin-bottom: rem(8);
		}

		&__list,
		&__numbered-list {
			font-size: rem(12);
			line-height: rem(24);
			margin-bottom: rem(12);
		}

		&__list-item,
		&__numbered-list-item {
			margin-bottom: rem(6);
		}

		&__blockquote {
			font-size: rem(12);
			padding: rem(12) rem(16);
			margin: rem(12) 0;
		}

		&__table {
			font-size: rem(12);

			th,
			td {
				padding: rem(8) rem(12);
			}
		}
	}
}
</style>